import { ProfileSectionConnected } from '@/features/settings/connected'

export default function SettingsProfilePage() {
  return <ProfileSectionConnected />
}
